import { db } from "@utils/IndexedDb";

import { GroupedLabelValue, LocationDB } from "@/types";

export const MAX_AUTOCOMPLETE_SELECTION = 3;

// A basic function to compute the similarity between two strings using Jaro-Winkler.
export function stringSimilarity(s1: string, s2: string): number {
  const m = s1.length > s2.length ? s1.length : s2.length;
  let matchingChars = 0;
  for (let i = 0; i < Math.min(s1.length, s2.length); i++) {
    if (s1[i] === s2[i]) {
      matchingChars++;
    }
  }
  return matchingChars / m;
}

export function sortByLabelSimilarity(arr: LocationDB[], search: string): LocationDB[] {
  return arr.sort((a, b) => {
    const similarityA = stringSimilarity((a.name as string).toLowerCase(), search.toLowerCase());
    const similarityB = stringSimilarity((b.name as string).toLowerCase(), search.toLowerCase());
    return similarityB - similarityA;
  });
}

export const highlightInput = (text: string, input: string): string => {
  if (input.trim() !== "") {
    const regexp = new RegExp(`(${input})`, "gi");
    const regexpMatch = text.match(regexp);
    if (regexpMatch) {
      const newText = text.replace(regexpMatch[0], `<strong>${regexpMatch[0]}</strong>`);
      return newText;
    }
    return text;
  }
  return text;
};

export function groupLocation(locations: LocationDB[]): GroupedLabelValue {
  const groupedLocations: GroupedLabelValue = {
    City: [],
    Location: [],
    Project: [],
  };
  locations.forEach((location) => {
    const locationType = location.type;
    if (["Location", "Area"].includes(locationType as string)) {
      groupedLocations["Location"].push(location);
    } else {
      groupedLocations[locationType as string].push(location);
    }
  });
  return groupedLocations;
}

export const valuesToString = (plainValue: string): string[] => {
  return plainValue
    .split(",")
    .filter((value) => value !== "")
    .map((item) => item.trim());
};

export const locationLabelFromCategories = async (category: string[]): Promise<string> => {
  let currentTextValue = "";
  /*if (category.length > 0) {
    const items = await db.LOCATIONS.where("id").anyOf(category).toArray();
    currentTextValue = `${items[0].name}`;
    if (items.length > 1) {
      currentTextValue += "";
    }
    if (items.length < MAX_AUTOCOMPLETE_SELECTION) {
      currentTextValue += "";
    }
  } */
  if (category.length > 0) {
    const items = await db.LOCATIONS.where("id").anyOf(category).toArray();
    const sliced = items.slice(0, MAX_AUTOCOMPLETE_SELECTION);
    if (sliced.length > 1) {
      currentTextValue = `${sliced.map((item) => item.name).join(", ")}`;
    } else if (sliced.length > 0) {
      currentTextValue = `${sliced[0].name}, `;
    }
    if (items.length > MAX_AUTOCOMPLETE_SELECTION) {
      currentTextValue += `+`;
    }
  }

  return currentTextValue;
};

export const locationsFromID = async (category: string[]): Promise<string[]> => {
  if (category.length > 0) {
    const items = await db.LOCATIONS.where("id").anyOf(category).toArray();
    return items.map((item) => item.name);
  }
  return [];
};
